import React from "react";

const PrevCourseSelect = ({ prevCourseCode, prevCourses, handleChange }) => {   
    return (
        <>
            <div className="input-field">
                <div className="top-input">
                    Course
                    <div className="required">
                        *
                    </div>
                </div>
                <select className="metric-select docker-select" value={prevCourseCode} onChange={(e) => {handleChange(e.target.value)}}>
                    <option key={''} value={''}>
                        None
                    </option>
                    {
                        prevCourses?.map((course) => {
                            return (
                                <option key={course.courseCode} value={course.courseCode}>
                                    {course.name}
                                </option>
                            )                    
                        })
                    }
                </select>
            </div>
        </>
    );
}

export default PrevCourseSelect;